import  * as actions from '../actions/actionTypes';
import { IStatsRankingState, IState } from '../store/state';
import { IFishnetRankingData } from '../api/fishnet/types';

const statsRanking = ( state: IStatsRankingState = [], action: any ) : IStatsRankingState => {
  switch (action.type) {
    case actions.FETCH_STATS_RANKING_SUCCEEDED:
      return [... (action.data.doc[0].data as IFishnetRankingData).teams ];
    default:
      return state;
  }
};

export type PlayerRank = {
  rank: number
  points: number
}

export type RanksByPlayerId = Record<number,PlayerRank>;

// unfortunately the feeds contains data sorted by player rank with player information in that object
// we need it the opposite way, playerId with the according rank, therefore we just create the according data ourselves
export const getRankAccordingToPlayerId = (state: IState) => {
  // feed has already been read?
  if(state.statsRanking && state.statsRanking[0]) {
    const rankAccordingToPlayerId : RanksByPlayerId = {};

    // we need to resort: playerId is the key while rank is the property
    state.statsRanking.forEach( teamRanking => {
        rankAccordingToPlayerId[teamRanking.team.uid] = {
          rank: teamRanking.ranking,
          points: teamRanking.points
        }
    });

    return rankAccordingToPlayerId;
  }
  else {
    return null;
  }
};

export const getNumberOfTeams = ( state: IState ) => {
  return state.statsRanking.length
}

export const getRankByTeamId = ( state: IState, teamId: number ) => {
  return state.statsRanking.find(rank => rank.team.uid === teamId)
}

export const getRankingByTeamId = ( state: IState, teamId: number ) => {
  const rank = getRankByTeamId( state, teamId );
  return rank ? rank.ranking : null
}

export const getPointByTeamId = ( state: IState, teamId: number ) => {
  const rank = getRankByTeamId( state, teamId );
  return rank ? rank.points : null
}

export default statsRanking;
